export default __webpack_public_path__ + "static/media/ally_logo.2a978d78.svg";